import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebService } from '../web/web.service';
import { tap } from 'rxjs/operators';
import { PortalsService } from '../portals/portals.service';

/**
 * PartnerService — creación administrativa de partners (super admin) y
 * carga de catálogos necesarios para el formulario.
 *
 * SRP: solo orquesta las llamadas HTTP de partner sobre WebService.
 */
@Injectable({ providedIn: 'root' })
export class PartnerService {
  constructor(
    private webService: WebService,
    private portalsService: PortalsService
  ) {}

  getBanks(partnerId: number): Observable<any> {
    return this.webService.get(
      `${this.webService.HOST}/onboardingBanks/${this.webService.ONBOARDING_ID}/partner/${partnerId}`
    );
  }

  getCountries(): Observable<any> {
    return this.webService.get(`${this.webService.HOST}/country`);
  }

  getCitiesByCountry(countryId: number): Observable<any> {
    return this.webService.get(`${this.webService.HOST}/city/country/${countryId}`);
  }

  getWhatsappNumbers(): Observable<any> {
    return this.webService.get(`${this.webService.HOST}/whatsapp`);
  }

  adminCreatePartner(partner: any): Observable<any> {
    return this.webService.post(
      { partner },
      `${this.webService.HOST}/onboarding/partner/admin`
    ).pipe(tap(() => this.portalsService.refresh()));
  }
}
